import React, { Fragment, Suspense } from "react";
import { WidgetProps } from "@rjsf/core";
import HPRPeoplePicker, { TPickerValue } from '../../../../../sg-hpr/components/persons/PersonPicker'
import { useApplicationConfiguration } from "@/@auditoinnit/auditoinnit/configuration/ConfigurationContext";


export interface IPersonPickerOptions {
    requiredCerts?: string[],
    excludeUncertified?: boolean;
};

export const PersonPickerWidget: React.FC<WidgetProps> = (props) => {

    const {
        onChange,
        value,
        schema,
        options,
    } = props;

    const appParameters = useApplicationConfiguration()
    const isMulti = schema.type === "array";

    const handleOnChange = (value: TPickerValue) => {
        onChange(value);
    }

    const { requiredCerts, excludeUncertified = false, } = options as IPersonPickerOptions;

    const noEmptyArrayItem = value && Array.isArray(value) ? [...value].filter((personId) => personId) : value
    return (
        <Fragment>
            <Suspense fallback={<div></div>}>
                <HPRPeoplePicker
                    onChange={handleOnChange}
                    isMulti={isMulti}
                    value={noEmptyArrayItem}
                    requiredCerts={Array.isArray(requiredCerts) ? requiredCerts : []}
                    inputForCertStartDate={appParameters.inputForHprCertificationStartDate}
                    excludeUncertified={excludeUncertified}
                />
            </Suspense>
        </Fragment>
    );
};
